/**
 * Mobile Sidebar Menu
 * Handles open/close, submenu navigation, body scroll lock
 */
(function () {
  const SELECTORS = {
    sidebar: '.mobile-sidebar',
    overlay: '.mobile-sidebar-overlay',
    closeBtn: '.mobile-sidebar-close',
    openBtn: '[data-mobile-sidebar-open]',
    menuItem: '[data-mobile-submenu-trigger]',
    submenuPanel: '.mobile-sidebar__submenu-panel',
    submenuBack: '.mobile-sidebar__submenu-back',
    grandchildTrigger: '[data-mobile-grandchild-trigger]',
    grandchildPanel: '.mobile-sidebar__grandchild-panel',
    grandchildBack: '.mobile-sidebar__grandchild-back',
  };

  function init() {
    const sidebar = document.querySelector(SELECTORS.sidebar);
    if (!sidebar) return;

    const overlay = document.querySelector(SELECTORS.overlay);
    const closeBtn = document.querySelector(SELECTORS.closeBtn);
    const openBtns = document.querySelectorAll(SELECTORS.openBtn);

    // Header wrapper uses AOS (transform), which traps fixed children — lift menu UI to body.
    [overlay, sidebar, closeBtn].forEach(function (el) {
      if (el && el.parentElement !== document.body) {
        document.body.appendChild(el);
      }
    });

    // Open sidebar
    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openSidebar(sidebar, overlay, closeBtn);
      });
    });

    // Close sidebar
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeSidebar(sidebar, overlay, closeBtn);
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        closeSidebar(sidebar, overlay, closeBtn);
      });
    }

    // Submenu triggers
    const menuItems = sidebar.querySelectorAll(SELECTORS.menuItem);
    menuItems.forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = item.getAttribute('data-mobile-submenu-trigger');
        const panel = sidebar.querySelector(
          '.mobile-sidebar__submenu-panel[data-submenu-id="' + targetId + '"]'
        );
        if (panel) {
          panel.classList.add('is-open');
        }
      });
    });

    // Submenu back buttons
    const backBtns = sidebar.querySelectorAll(SELECTORS.submenuBack);
    backBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const panel = btn.closest(SELECTORS.submenuPanel);
        if (panel) {
          panel.classList.remove('is-open');
        }
      });
    });

    // Grandchild triggers
    const grandchildTriggers = sidebar.querySelectorAll(SELECTORS.grandchildTrigger);
    grandchildTriggers.forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = item.getAttribute('data-mobile-grandchild-trigger');
        const panel = sidebar.querySelector(
          '.mobile-sidebar__grandchild-panel[data-grandchild-id="' + targetId + '"]'
        );
        if (panel) {
          panel.classList.add('is-open');
        }
      });
    });

    // Grandchild back buttons
    const grandchildBacks = sidebar.querySelectorAll(SELECTORS.grandchildBack);
    grandchildBacks.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const panel = btn.closest('.mobile-sidebar__grandchild-panel');
        if (panel) {
          panel.classList.remove('is-open');
        }
      });
    });

    // Close on ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
        closeSidebar(sidebar, overlay, closeBtn);
      }
    });
  }

  function openSidebar(sidebar, overlay, closeBtn) {
    sidebar.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    if (closeBtn) closeBtn.classList.add('is-open');
    document.body.classList.add('mobile-sidebar-open');
  }

  function closeSidebar(sidebar, overlay, closeBtn) {
    sidebar.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    if (closeBtn) closeBtn.classList.remove('is-open');
    document.body.classList.remove('mobile-sidebar-open');

    // Close any open submenus after transition
    setTimeout(function () {
      sidebar.querySelectorAll('.mobile-sidebar__submenu-panel.is-open').forEach(function (p) {
        p.classList.remove('is-open');
      });
      sidebar.querySelectorAll('.mobile-sidebar__grandchild-panel.is-open').forEach(function (p) {
        p.classList.remove('is-open');
      });
    }, 350);
  }

  // Initialize when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
